import React from "react";

const PBIIcon: React.FC = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M4 14H8V20H4V14Z" fill="currentColor" />
    <path d="M10 9H14V20H10V9Z" fill="currentColor" />
    <path d="M16 4H20V20H16V4Z" fill="currentColor" />
  </svg>
);

export default PBIIcon;
